import { createContext, useContext, useState, useMemo, useCallback } from "react";
import { translations } from "@/i18n";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("en");
  const t = translations[lang];
  const toggleLang = useCallback(() => setLang((prev) => (prev === "en" ? "es" : "en")), [setLang]);
  const value = useMemo(() => ({ lang, setLang, toggleLang, t }), [lang, t, toggleLang]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
